import listSaga from './listSaga'
import oneCountrySaga from './oneCountrySaga'

const countriesSagas = [listSaga(), oneCountrySaga()]

export default countriesSagas
